import { SVGProps } from "react"

export const IconRightArrow = ({
  width = 16,
  height = 16,
  color = "var(--mantine-color-white)",
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M73.6992 33.8622V31.4348C62.305 30.5853 49.8197 23.6672 49.8197 0H62.7898C62.7898 27.551 83.639 33.6195 95.0332 33.6195V46.242C83.639 46.242 62.7898 52.3105 62.7898 79.8615H49.8197C49.8197 56.1943 62.305 49.2762 73.6992 48.4267V45.9993H0V33.8622H73.6992Z"
        fill={color}
      />
    </svg>
  )
}
